import { NavLink } from 'react-router-dom';
import { Home, Search, Music, TrendingUp, User } from 'lucide-react';
import { cn } from '../../lib/cn.js';

const items = [
  { to: '/', icon: Home, label: 'Inicio' },
  { to: '/search', icon: Search, label: 'Buscar' },
  { to: '/genres', icon: Music, label: 'Géneros' },
  { to: '/trending', icon: TrendingUp, label: 'Trending' },
  { to: '/login', icon: User, label: 'Cuenta' },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-surface border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around h-14">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 px-3 py-1.5 text-xs transition-colors',
                isActive ? 'text-primary' : 'text-text-muted',
              )
            }
          >
            <item.icon size={20} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
